import { createMsalConfig } from '@auth/msalConfig';

export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'login',
};

export const msalInstance = createMsalConfig({
  clientId: import.meta.env.VITE_AZURE_CLINICAL_CLIENT_ID,
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID,
});

export const apiRequest = {
  scopes: [
    `api://${import.meta.env.VITE_AZURE_CLINICAL_CLIENT_ID}/user_impersonation`,
  ],
};
